import { AmlService } from './AML/aml.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus, AuthenticationResult, PopupRequest, EventMessage, EventType } from '@azure/msal-browser';
import { UserDetail, UserService } from './modules/shared/user.service';
import { filter, Subject, Subscription, takeUntil, take } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as fromModel from './modules/shared/models';
import { HttpService } from './modules/shared/http.service';
import { Utils } from './modules/shared/utils';
import { Constant } from './modules/shared/constants';
// Corrected import path or ensure the file exists
import * as fromModels from './modules/shared/models';
import { MatMenuTrigger } from '@angular/material/menu';
import { InitService } from './modules/shared/init.service';
import { AdvisorService } from './modules/shared/advisors-tree-filter/advisor.service';
import { isInIframe } from './app.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit ,OnDestroy {
  isIframe = false;
  private readonly _destroying$ = new Subject<void>();
  isFirstTimeLoggedin = false;
  jwtHelperSvc: JwtHelperService | undefined;
  loggedIn: boolean = false;
  _urlSub?: Subscription;
  user: UserDetail | undefined;

  loggedInUser: UserDetail | undefined;
  appRole: fromModels.USERROLE | any;
  // orgRole: fromModels.USERROLE | any;
  tempRole: fromModels.USERROLE | any;
  isVisibleRoleSelection=true;
  isDivisionSelection=true;
  showProgress = false;
  runMessage:string='';
  repIds: string[]=[];
  @ViewChild('advMenuTrigger') advMenuTrigger: MatMenuTrigger | undefined;
  advTree: fromModels.TodoItemNode[] = [];
  isHome: boolean = false;
  userSub?: Subscription;


  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private router: Router,
    private userService: UserService,
    private amlService: AmlService,
   
    private _advisor:AdvisorService,
  
  ) {

    this.isIframe = isInIframe;

    this._urlSub = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // * change of route detected
        // Use only the path (strip query params) to avoid matching 'groupId' in query string
        const urlPath = event.url.split('?')[0];
        if(urlPath.includes('/group')||urlPath.includes('/review') ) {
          this.isHome = false;}else{
          this.isHome = true;
          }

        console.log("NavigationEnd: " + event.url);
       
      }
    });
  }


  ngOnInit() {
    

    this.userService.traceMsg("******** Supervision - App - Init ********");

    // Event-based login detection
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          msg.eventType === EventType.LOGOUT_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        if (result.eventType === EventType.LOGOUT_SUCCESS) {
          this.loggedIn = false;
          return;
        }

        const payload = result.payload as AuthenticationResult;
        if (payload && payload.account) {
          this.authService.instance.setActiveAccount(payload.account);
        }

        // Extract user info from ID token on first login
        if (!this.isFirstTimeLoggedin) {
          this.isFirstTimeLoggedin = true;
          this.checkAccount();
          this.userService.traceMsg("Supervision UI: idtoken: " + payload.idToken);
          this.getUserName(payload.idToken);
          this.divisionPopulation();
        }

        this.loggedIn = true;
      });

    // Wait for MSAL init to complete, then check/set active account
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });

this.userSub = this.userService.userSubject.subscribe((user) => {

      if (user) {
        this.loggedInUser = user;
        
      }})

      // this.checkAccount();
      // if (!this.loggedIn) {
      //   this.login();
      // } else {
      //   this.getUserName(localStorage.getItem('msal.idtoken') ?? '');
      // }
    
    }


        
divisionPopulation(){

  this._advisor
  .getAdvisors(
    this.loggedInUser?.role === fromModels.USERROLE.DBD
      ? this.loggedInUser.userid
      : '',
    this.loggedInUser?.role === fromModels.USERROLE.PA ? true : false
  )
  .subscribe({
    next: (adv: fromModels.AdvisorHirerarchy) => {
      if (adv && adv.regions && adv.regions.length) {
        this.prepareAdvisorsTree(adv);
      }
    },
    error: (err) => {
      this.userService.traceMsg(
        'PeriodicClientReview -> Error getting advisors data.',
        err,
        'Error'
      );
    },
  });
}


    private prepareAdvisorsTree(adv: any) {
      let advisorsTreeData: any[] = [];
      let id = 1;
      let code = '0.1';
      this.advTree = [];
      //regions
      adv.regions.forEach((r: any) => {
        let region = {
          text: r.regName,
          code: code.toString(),
          isChecked: false,
          id: 'R' + id.toString(),
          color: '#004377',
        };
        advisorsTreeData.push(region);
        id++;
  
        //hubs
        r.hubs.forEach((h: any, hi: any) => {
          let hub = {
            text: h.hubName,
            code: `${code.toString()}.${hi + 1}`,
            isChecked: false,
            id: 'H' + id.toString(),
            color: '#5c60b7',
          };
          advisorsTreeData.push(hub);
          id++;
  
          //teams
          h.teams.forEach((t: any, ti: any) => {
            let team = {
              text: t.teamName,
              code: `${hub.code}.${ti + 1}`,
              isChecked: false,
              id: 'T' + id.toString(),
              color: '#8A39E1',
            };
            advisorsTreeData.push(team);
            id++;
  
            //advisors
            t.advisors.forEach((a: any, ai: any) => {
              let advisor = {
                text: `${a.repId} - ${a.repName}`,
                code: `${team.code}.${ai + 1}`,
                isChecked: false,
                id: a.repId,
                color: 'black',
              };
              advisorsTreeData.push(advisor);
              id++;
            });
          });
        });
        code = (Number(code) + 0.1).toFixed(1);
      });
      this.advTree = advisorsTreeData;
    }

    closeAdvTree() {
      if (this.advMenuTrigger) {
        this.advMenuTrigger.closeMenu();
      }
    }

    advListChanged(_repIds: string[]) {
      this.repIds = _repIds;
      this.amlService.setRepIDS(_repIds);
      
  
     
      this.closeAdvTree();
    }


      ngOnDestroy() {
       // this._urlSub?.unsubscribe();
        this._destroying$.next(undefined);
        this._destroying$.complete();
        this.userSub?.unsubscribe();
      }
    
      checkAccount() {
        this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
        if (this.loggedIn) {
          this.getUserName(localStorage.getItem('msal.idtoken') ?? '');
        }
      }

      private processPostLogin() {
        this.checkAccount();
        this.divisionPopulation();
      }

      /** MSAL v4: check and set the active account */
      private checkAndSetActiveAccount() {
        const activeAccount = this.authService.instance.getActiveAccount();

        if (!activeAccount) {
          const accounts = this.authService.instance.getAllAccounts();
          if (accounts.length > 0) {
            this.authService.instance.setActiveAccount(accounts[0]);
            this.loggedIn = true;
            this.processPostLogin();
          } else {
            this.loggedIn = false;
            // Iframe: attempt silent SSO, fall back to popup
            if (this.isIframe) {
              this.loginSilentForIframe();
            }
            // Standalone: MsalGuard on routes will trigger loginPopup
          }
        } else {
          this.loggedIn = true;
          this.processPostLogin();
        }
      }

      /** Iframe login: ssoSilent → loginPopup fallback */
      private loginSilentForIframe() {
        const silentRequest = { scopes: Constant.config.scopes };

        this.authService.instance.ssoSilent(silentRequest)
          .then((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.loggedIn = true;
            this.getUserName(response.idToken);
            this.divisionPopulation();
          })
          .catch(() => {
            this.authService.loginPopup({
              scopes: Constant.config.scopes
            } as PopupRequest)
              .subscribe((response: AuthenticationResult) => {
                this.authService.instance.setActiveAccount(response.account);
                this.loggedIn = true;
                this.getUserName(response.idToken);
                this.divisionPopulation();
              });
          });
      }
    
      login() {
        if (this.isIframe) {
          // Iframe: use popup (redirect blocked by X-Frame-Options)
          this.authService.loginPopup({ scopes: Constant.config.scopes } as PopupRequest)
            .subscribe((response: AuthenticationResult) => {
              this.authService.instance.setActiveAccount(response.account);
            });
        } else {
          // Standalone: use popup flow
          this.authService.loginPopup({ scopes: Constant.config.scopes } as PopupRequest)
            .subscribe((response: AuthenticationResult) => {
              this.authService.instance.setActiveAccount(response.account);
            });
        }
      }
    
      logout() {
        this.authService.logout();
      }
    
    
    
    
    
  private getRole(roles: string[]) {
    console.log(this.router.url)
    let role = fromModel.USERROLE.PA;
    if (roles && roles.length > 0) {
      let r: any;
    
      r = roles.find(_role => _role === "RCM.PMTECH");
      if (r !== undefined) {
        role = fromModel.USERROLE.SUPER;
        return role;
      }
      r = roles.find(_role => _role === "Advisory.AML");
      if (r !== undefined) {
        role = fromModel.USERROLE.AML;
        return role;
      }

      r = roles.find(_role => _role === "Advisory.OLT");
      if (r !== undefined) {
        role = fromModel.USERROLE.DBD;
        return role;
      }

      r = roles.find(_role => _role === "Advisory.ADBD");
      if (r !== undefined) {
        role = fromModel.USERROLE.DBD;
        return role;
      }

      r = roles.find(_role => _role === "Advisory.All");
      if (r !== undefined) {
        role = fromModel.USERROLE.PA;
        return role;
      }






      r = roles.find(_role => _role === "Advisory.HomeOffice");
      if (r !== undefined) {
        role = fromModel.USERROLE.HO;
        return role;
      }






    }
    return role;
  }
    
    
      private getUserName(idtoken: string) {
        if (!this.jwtHelperSvc) {
          this.jwtHelperSvc = new JwtHelperService();
        }
        if (idtoken) {
          const decodedToken = this.jwtHelperSvc.decodeToken(idtoken);
          if (!this.userService.getUser()) {
            console.log("***********************************GET USER NAME****************************");
            let _u = new UserDetail();
            _u.name = decodedToken.name || '';
            _u.userid = decodedToken.preferred_username || '';
            _u.poolIds = decodedToken.poolIds || '';
            _u.repId = decodedToken.primaryid || '';
    
            if (decodedToken.roles) {
              console.log("Roles: " + JSON.stringify(decodedToken.roles));
              this.userService.traceMsg("Supervision UI. Roles: " + JSON.stringify(decodedToken.roles));
            } else {
              this.userService.traceMsg("Supervision UI: Roles not found");
            }
    
            this.userService.traceMsg("Supervision UI: name: " + _u.name + " T:" + idtoken);
    
            _u.role = this.getRole(decodedToken?.roles);
             this.tempRole =_u.role;
            this.amlService.setRole(_u.role);
            this.amlService.setapplicationRole(_u.role);
            this.initUser(_u);
    
         
    
          }
        }
      }
    
      private initUser(_u: UserDetail) {
        this.user = _u;
        this.userService.setUser(_u);
      }




      //// fOR ui

      // get showUserSel() {
      //   if (Constant.config.env === 'QA' || Constant.config.env === 'DEV') {
      //     return (
      //       this.orgRole !== fromModels.USERROLE.FA &&
      //       this.orgRole !== fromModels.USERROLE.BM
      //     );
      //   } else if (Constant.config.env === 'PROD') {
      //     return this.orgRole === fromModels.USERROLE.SUPER;
      //   } else {
      //     return false;
      //   }
      // }
      
      
      changeUser() {
       
        this.amlService.setRole(this.tempRole);
        this.amlService.setapplicationRole(this.tempRole);
        
        //  this.getPeriodicClientData();
        //this.annualReviewService.setRole(role);
      }

  get showUserSel() {
    const env = Constant.config.env?.toUpperCase();
    if (env === 'QA' || env === 'DEV') {
      return (
        this.loggedInUser?.role !== fromModels.USERROLE.PA &&
        this.loggedInUser?.role !== fromModels.USERROLE.DBD
      );
    } else if (env === 'PROD') {
      return this.loggedInUser?.role === fromModels.USERROLE.SUPER;
    } else {
      return false;
    }
  }
    
      ngAfterViewInit() {
        // Automatically select the radio button based on the user's role
        if (this.loggedInUser && this.loggedInUser.role) {
          this.tempRole = this.loggedInUser.role;
        }
      }
}
